export default {
	btnAdd: 'Ajouter',
	btnText: 'Renseigner des facteurs de risque',
	btnDeclinedTransition: 'Refuser',
	btnFinalizedTransition: 'Valider',
	btnWaitingTransition: 'À traiter',
	patientLinkSuccess: 'La liaison a été ajoutée',
	form: {
		nir: {
			label:
				'Numéro de sécurité sociale (NIR Ouvrant Droit – 13 caractères)',
			rules: [
				{
					name: 'exactLength',
					args: [13, true]
				},
				{
					name: 'requiredFn'
				}
			]
		},
		patients: {
			rules: [
				{
					name: 'requiredFn'
				}
			],
			headers: [
				{
					text: 'Prénom Nom',
					align: 'left',
					value: 'name'
				},
				{
					text: 'Date de naissance',
					align: 'left',
					value: 'birthDate',
					cellType: 'date'
				},
				{
					text: 'Déjà inscrit',
					align: 'left',
					value: 'linkedToProjectLabel'
				}
			]
		}
	},
	delete: 'Supprimer',
	finalize: 'Valider',
	decline: 'Refuser',
	treat: 'À traiter',
	edit: 'Modifier',
	seeDetails: 'Visualiser',
	yesLabel: 'Oui',
	noLabel: 'Non'
};
